/* tslint:disable */
/* eslint-disable */
/**
 * FanFair Complete API
 * Complete API documentation for FanFair platform including both public and private endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreatePartnerWebhookRequest } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { PartnerWebhookCreatedResponse } from '../models';
// @ts-ignore
import type { PartnerWebhookListResponse } from '../models';
// @ts-ignore
import type { PartnerWebhookResponse } from '../models';
// @ts-ignore
import type { UpdatePartnerWebhookRequest } from '../models';
// @ts-ignore
import type { WebhookSecretRegenerationResponse } from '../models';
// @ts-ignore
import type { WebhookStatusUpdateResponse } from '../models';
/**
 * WebhooksApi - axios parameter creator
 * @export
 */
export const WebhooksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Activate a webhook configuration to start receiving events. Supports both API key authentication with webhook:write scope and partner user token authentication. API keys must include the webhook:write scope.
         * @summary Activate webhook configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activatePartnerWebhook: async (partnerId: string, webhookId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('activatePartnerWebhook', 'partnerId', partnerId)
            // verify required parameter 'webhookId' is not null or undefined
            assertParamExists('activatePartnerWebhook', 'webhookId', webhookId)
            const localVarPath = `/api/v1/partners/{partnerId}/webhooks/{webhookId}/activate`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"webhookId"}}`, encodeURIComponent(String(webhookId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new webhook configuration for a partner. Supports both API key authentication with webhook:write scope and partner user token authentication. API keys must include the webhook:write scope.
         * @summary Create new webhook configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {CreatePartnerWebhookRequest} createPartnerWebhookRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerWebhook: async (partnerId: string, createPartnerWebhookRequest: CreatePartnerWebhookRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('createPartnerWebhook', 'partnerId', partnerId)
            // verify required parameter 'createPartnerWebhookRequest' is not null or undefined
            assertParamExists('createPartnerWebhook', 'createPartnerWebhookRequest', createPartnerWebhookRequest)
            const localVarPath = `/api/v1/partners/{partnerId}/webhooks`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPartnerWebhookRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deactivate a webhook configuration to stop receiving events. Supports both API key authentication with webhook:write scope and partner user token authentication. API keys must include the webhook:write scope.
         * @summary Deactivate webhook configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivatePartnerWebhook: async (partnerId: string, webhookId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('deactivatePartnerWebhook', 'partnerId', partnerId)
            // verify required parameter 'webhookId' is not null or undefined
            assertParamExists('deactivatePartnerWebhook', 'webhookId', webhookId)
            const localVarPath = `/api/v1/partners/{partnerId}/webhooks/{webhookId}/deactivate`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"webhookId"}}`, encodeURIComponent(String(webhookId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a webhook configuration permanently. Supports both API key authentication with webhook:write scope and partner user token authentication. API keys must include the webhook:write scope.
         * @summary Delete webhook configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePartnerWebhook: async (partnerId: string, webhookId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('deletePartnerWebhook', 'partnerId', partnerId)
            // verify required parameter 'webhookId' is not null or undefined
            assertParamExists('deletePartnerWebhook', 'webhookId', webhookId)
            const localVarPath = `/api/v1/partners/{partnerId}/webhooks/{webhookId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"webhookId"}}`, encodeURIComponent(String(webhookId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve details of a specific webhook configuration. Supports both API key authentication with webhook:read scope and partner user token authentication. API keys must include the webhook:read scope.
         * @summary Get specific webhook configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerWebhook: async (partnerId: string, webhookId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('getPartnerWebhook', 'partnerId', partnerId)
            // verify required parameter 'webhookId' is not null or undefined
            assertParamExists('getPartnerWebhook', 'webhookId', webhookId)
            const localVarPath = `/api/v1/partners/{partnerId}/webhooks/{webhookId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"webhookId"}}`, encodeURIComponent(String(webhookId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all webhook configurations for a partner. Supports both API key authentication with webhook:read scope and partner user token authentication. API keys must include the webhook:read scope.
         * @summary List partner\'s webhook configurations
         * @param {string} partnerId Partner ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerWebhooks: async (partnerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('listPartnerWebhooks', 'partnerId', partnerId)
            const localVarPath = `/api/v1/partners/{partnerId}/webhooks`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate a new secret key for webhook signature validation. The old secret key will be invalidated. Supports both API key authentication with webhook:write scope and partner user token authentication. API keys must include the webhook:write scope.
         * @summary Regenerate webhook secret key
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regeneratePartnerWebhookSecret: async (partnerId: string, webhookId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('regeneratePartnerWebhookSecret', 'partnerId', partnerId)
            // verify required parameter 'webhookId' is not null or undefined
            assertParamExists('regeneratePartnerWebhookSecret', 'webhookId', webhookId)
            const localVarPath = `/api/v1/partners/{partnerId}/webhooks/{webhookId}/regenerate-secret`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"webhookId"}}`, encodeURIComponent(String(webhookId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing webhook configuration. Supports both API key authentication with webhook:write scope and partner user token authentication. API keys must include the webhook:write scope.
         * @summary Update webhook configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {UpdatePartnerWebhookRequest} updatePartnerWebhookRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartnerWebhook: async (partnerId: string, webhookId: string, updatePartnerWebhookRequest: UpdatePartnerWebhookRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('updatePartnerWebhook', 'partnerId', partnerId)
            // verify required parameter 'webhookId' is not null or undefined
            assertParamExists('updatePartnerWebhook', 'webhookId', webhookId)
            // verify required parameter 'updatePartnerWebhookRequest' is not null or undefined
            assertParamExists('updatePartnerWebhook', 'updatePartnerWebhookRequest', updatePartnerWebhookRequest)
            const localVarPath = `/api/v1/partners/{partnerId}/webhooks/{webhookId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"webhookId"}}`, encodeURIComponent(String(webhookId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePartnerWebhookRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebhooksApi - functional programming interface
 * @export
 */
export const WebhooksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebhooksApiAxiosParamCreator(configuration)
    return {
        /**
         * Activate a webhook configuration to start receiving events. Supports both API key authentication with webhook:write scope and partner user token authentication. API keys must include the webhook:write scope.
         * @summary Activate webhook configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activatePartnerWebhook(partnerId: string, webhookId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebhookStatusUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activatePartnerWebhook(partnerId, webhookId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhooksApi.activatePartnerWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new webhook configuration for a partner. Supports both API key authentication with webhook:write scope and partner user token authentication. API keys must include the webhook:write scope.
         * @summary Create new webhook configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {CreatePartnerWebhookRequest} createPartnerWebhookRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPartnerWebhook(partnerId: string, createPartnerWebhookRequest: CreatePartnerWebhookRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerWebhookCreatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPartnerWebhook(partnerId, createPartnerWebhookRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhooksApi.createPartnerWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deactivate a webhook configuration to stop receiving events. Supports both API key authentication with webhook:write scope and partner user token authentication. API keys must include the webhook:write scope.
         * @summary Deactivate webhook configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivatePartnerWebhook(partnerId: string, webhookId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebhookStatusUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivatePartnerWebhook(partnerId, webhookId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhooksApi.deactivatePartnerWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a webhook configuration permanently. Supports both API key authentication with webhook:write scope and partner user token authentication. API keys must include the webhook:write scope.
         * @summary Delete webhook configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePartnerWebhook(partnerId: string, webhookId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePartnerWebhook(partnerId, webhookId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhooksApi.deletePartnerWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve details of a specific webhook configuration. Supports both API key authentication with webhook:read scope and partner user token authentication. API keys must include the webhook:read scope.
         * @summary Get specific webhook configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnerWebhook(partnerId: string, webhookId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerWebhookResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartnerWebhook(partnerId, webhookId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhooksApi.getPartnerWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all webhook configurations for a partner. Supports both API key authentication with webhook:read scope and partner user token authentication. API keys must include the webhook:read scope.
         * @summary List partner\'s webhook configurations
         * @param {string} partnerId Partner ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPartnerWebhooks(partnerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerWebhookListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPartnerWebhooks(partnerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhooksApi.listPartnerWebhooks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate a new secret key for webhook signature validation. The old secret key will be invalidated. Supports both API key authentication with webhook:write scope and partner user token authentication. API keys must include the webhook:write scope.
         * @summary Regenerate webhook secret key
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async regeneratePartnerWebhookSecret(partnerId: string, webhookId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebhookSecretRegenerationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.regeneratePartnerWebhookSecret(partnerId, webhookId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhooksApi.regeneratePartnerWebhookSecret']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing webhook configuration. Supports both API key authentication with webhook:write scope and partner user token authentication. API keys must include the webhook:write scope.
         * @summary Update webhook configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {UpdatePartnerWebhookRequest} updatePartnerWebhookRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePartnerWebhook(partnerId: string, webhookId: string, updatePartnerWebhookRequest: UpdatePartnerWebhookRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerWebhookResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePartnerWebhook(partnerId, webhookId, updatePartnerWebhookRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhooksApi.updatePartnerWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebhooksApi - factory interface
 * @export
 */
export const WebhooksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebhooksApiFp(configuration)
    return {
        /**
         * Activate a webhook configuration to start receiving events. Supports both API key authentication with webhook:write scope and partner user token authentication. API keys must include the webhook:write scope.
         * @summary Activate webhook configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activatePartnerWebhook(partnerId: string, webhookId: string, options?: RawAxiosRequestConfig): AxiosPromise<WebhookStatusUpdateResponse> {
            return localVarFp.activatePartnerWebhook(partnerId, webhookId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new webhook configuration for a partner. Supports both API key authentication with webhook:write scope and partner user token authentication. API keys must include the webhook:write scope.
         * @summary Create new webhook configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {CreatePartnerWebhookRequest} createPartnerWebhookRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerWebhook(partnerId: string, createPartnerWebhookRequest: CreatePartnerWebhookRequest, options?: RawAxiosRequestConfig): AxiosPromise<PartnerWebhookCreatedResponse> {
            return localVarFp.createPartnerWebhook(partnerId, createPartnerWebhookRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Deactivate a webhook configuration to stop receiving events. Supports both API key authentication with webhook:write scope and partner user token authentication. API keys must include the webhook:write scope.
         * @summary Deactivate webhook configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivatePartnerWebhook(partnerId: string, webhookId: string, options?: RawAxiosRequestConfig): AxiosPromise<WebhookStatusUpdateResponse> {
            return localVarFp.deactivatePartnerWebhook(partnerId, webhookId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a webhook configuration permanently. Supports both API key authentication with webhook:write scope and partner user token authentication. API keys must include the webhook:write scope.
         * @summary Delete webhook configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePartnerWebhook(partnerId: string, webhookId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePartnerWebhook(partnerId, webhookId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve details of a specific webhook configuration. Supports both API key authentication with webhook:read scope and partner user token authentication. API keys must include the webhook:read scope.
         * @summary Get specific webhook configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerWebhook(partnerId: string, webhookId: string, options?: RawAxiosRequestConfig): AxiosPromise<PartnerWebhookResponse> {
            return localVarFp.getPartnerWebhook(partnerId, webhookId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all webhook configurations for a partner. Supports both API key authentication with webhook:read scope and partner user token authentication. API keys must include the webhook:read scope.
         * @summary List partner\'s webhook configurations
         * @param {string} partnerId Partner ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerWebhooks(partnerId: string, options?: RawAxiosRequestConfig): AxiosPromise<PartnerWebhookListResponse> {
            return localVarFp.listPartnerWebhooks(partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate a new secret key for webhook signature validation. The old secret key will be invalidated. Supports both API key authentication with webhook:write scope and partner user token authentication. API keys must include the webhook:write scope.
         * @summary Regenerate webhook secret key
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regeneratePartnerWebhookSecret(partnerId: string, webhookId: string, options?: RawAxiosRequestConfig): AxiosPromise<WebhookSecretRegenerationResponse> {
            return localVarFp.regeneratePartnerWebhookSecret(partnerId, webhookId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing webhook configuration. Supports both API key authentication with webhook:write scope and partner user token authentication. API keys must include the webhook:write scope.
         * @summary Update webhook configuration
         * @param {string} partnerId Partner ID (ULID)
         * @param {string} webhookId Webhook configuration ID (ULID)
         * @param {UpdatePartnerWebhookRequest} updatePartnerWebhookRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartnerWebhook(partnerId: string, webhookId: string, updatePartnerWebhookRequest: UpdatePartnerWebhookRequest, options?: RawAxiosRequestConfig): AxiosPromise<PartnerWebhookResponse> {
            return localVarFp.updatePartnerWebhook(partnerId, webhookId, updatePartnerWebhookRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebhooksApi - object-oriented interface
 * @export
 * @class WebhooksApi
 * @extends {BaseAPI}
 */
export class WebhooksApi extends BaseAPI {
    /**
     * Activate a webhook configuration to start receiving events. Supports both API key authentication with webhook:write scope and partner user token authentication. API keys must include the webhook:write scope.
     * @summary Activate webhook configuration
     * @param {string} partnerId Partner ID (ULID)
     * @param {string} webhookId Webhook configuration ID (ULID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public activatePartnerWebhook(partnerId: string, webhookId: string, options?: RawAxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).activatePartnerWebhook(partnerId, webhookId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new webhook configuration for a partner. Supports both API key authentication with webhook:write scope and partner user token authentication. API keys must include the webhook:write scope.
     * @summary Create new webhook configuration
     * @param {string} partnerId Partner ID (ULID)
     * @param {CreatePartnerWebhookRequest} createPartnerWebhookRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public createPartnerWebhook(partnerId: string, createPartnerWebhookRequest: CreatePartnerWebhookRequest, options?: RawAxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).createPartnerWebhook(partnerId, createPartnerWebhookRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deactivate a webhook configuration to stop receiving events. Supports both API key authentication with webhook:write scope and partner user token authentication. API keys must include the webhook:write scope.
     * @summary Deactivate webhook configuration
     * @param {string} partnerId Partner ID (ULID)
     * @param {string} webhookId Webhook configuration ID (ULID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public deactivatePartnerWebhook(partnerId: string, webhookId: string, options?: RawAxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).deactivatePartnerWebhook(partnerId, webhookId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a webhook configuration permanently. Supports both API key authentication with webhook:write scope and partner user token authentication. API keys must include the webhook:write scope.
     * @summary Delete webhook configuration
     * @param {string} partnerId Partner ID (ULID)
     * @param {string} webhookId Webhook configuration ID (ULID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public deletePartnerWebhook(partnerId: string, webhookId: string, options?: RawAxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).deletePartnerWebhook(partnerId, webhookId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve details of a specific webhook configuration. Supports both API key authentication with webhook:read scope and partner user token authentication. API keys must include the webhook:read scope.
     * @summary Get specific webhook configuration
     * @param {string} partnerId Partner ID (ULID)
     * @param {string} webhookId Webhook configuration ID (ULID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public getPartnerWebhook(partnerId: string, webhookId: string, options?: RawAxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).getPartnerWebhook(partnerId, webhookId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve all webhook configurations for a partner. Supports both API key authentication with webhook:read scope and partner user token authentication. API keys must include the webhook:read scope.
     * @summary List partner\'s webhook configurations
     * @param {string} partnerId Partner ID (ULID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public listPartnerWebhooks(partnerId: string, options?: RawAxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).listPartnerWebhooks(partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate a new secret key for webhook signature validation. The old secret key will be invalidated. Supports both API key authentication with webhook:write scope and partner user token authentication. API keys must include the webhook:write scope.
     * @summary Regenerate webhook secret key
     * @param {string} partnerId Partner ID (ULID)
     * @param {string} webhookId Webhook configuration ID (ULID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public regeneratePartnerWebhookSecret(partnerId: string, webhookId: string, options?: RawAxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).regeneratePartnerWebhookSecret(partnerId, webhookId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing webhook configuration. Supports both API key authentication with webhook:write scope and partner user token authentication. API keys must include the webhook:write scope.
     * @summary Update webhook configuration
     * @param {string} partnerId Partner ID (ULID)
     * @param {string} webhookId Webhook configuration ID (ULID)
     * @param {UpdatePartnerWebhookRequest} updatePartnerWebhookRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public updatePartnerWebhook(partnerId: string, webhookId: string, updatePartnerWebhookRequest: UpdatePartnerWebhookRequest, options?: RawAxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).updatePartnerWebhook(partnerId, webhookId, updatePartnerWebhookRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

